module.exports = __webpack_public_path__ + "static/img/ent-detail-100.5e4882b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-100.jpg
// module id = D0QK
// module chunks = 51